import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber, Text } from '@shared/components'
import { Button, Col, Flex, Form, Input, Row } from 'antd'
import { Add, Trash } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { formProps } from './utils'

export const AtaCarnetGoods = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { goodsProps } = formProps(t)

  return (
    <Flex vertical gap={12}>
      <Text size={16} strong>
        {goodsProps.label}
      </Text>

      <Form.List name={goodsProps.name}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Row key={key} gutter={[12, 0]} align="bottom">
                <Col xs={24} lg={8}>
                  <Form.Item
                    {...restField}
                    name={[name, 'description']}
                    label={t('description')}
                    rules={[required]}
                  >
                    <Input placeholder={t('description')} />
                  </Form.Item>
                </Col>

                <Col xs={12} lg={4}>
                  <Form.Item
                    {...restField}
                    name={[name, 'quantity']}
                    label={t('quantity')}
                    rules={[required]}
                  >
                    <InputParsedNumber
                      className="w-full"
                      placeholder={t('quantity')}
                      min={0.01}
                      precision={2}
                    />
                  </Form.Item>
                </Col>

                <Col xs={12} lg={5}>
                  <Form.Item
                    {...restField}
                    name={[name, 'value']}
                    label={t('value')}
                    rules={[required]}
                  >
                    <InputParsedNumber
                      className="w-full"
                      placeholder={t('value')}
                      min={0.01}
                      precision={2}
                    />
                  </Form.Item>
                </Col>

                <Col xs={20} lg={5}>
                  <Form.Item
                    {...restField}
                    name={[name, 'notes']}
                    label={t('notes')}
                  >
                    <Input placeholder={t('notes')} />
                  </Form.Item>
                </Col>

                <Col xs={4} lg={2}>
                  <Form.Item>
                    <Button
                      danger
                      block
                      icon={<Trash size={16} />}
                      onClick={() => remove(name)}
                    />
                  </Form.Item>
                </Col>
              </Row>
            ))}

            <Button
              type="dashed"
              block
              icon={<Add size={16} />}
              onClick={() => add()}
            >
              {t('add_goods_item')}
            </Button>

            {/*
              Rendered directly instead of through Form.ErrorList: that component
              takes its colour from FormItemPrefixContext, which is absent here
              because the list sits under Form.List rather than a Form.Item, so
              the message came out unstyled.
            */}
            {!!errors.length && <Text color="colorError">{errors[0]}</Text>}
          </>
        )}
      </Form.List>
    </Flex>
  )
}
